<template>
    <dashboard-layout tit="근로자 계약서 관리" topBtn fullHeight>
        <template slot="topBtn">
            <v-row class="ma-n4">
                <v-col cols="auto" class="pa-4">
                    <employment-form-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn color="primary" v-bind="attrs" v-on="on" class="min-w-100px min-w-lg-140px">계약서 등록</v-btn>
                        </template>
                    </employment-form-form>
                </v-col>
                <v-col cols="auto" class="pa-4">
                    <employment-contract-form :forms="forms">
                        <template #activator="{ attrs, on }">
                            <v-btn color="secondary" v-bind="attrs" v-on="on" class="min-w-100px min-w-lg-140px">근로계약 체결</v-btn>
                        </template>
                    </employment-contract-form>
                </v-col>
            </v-row>
        </template>
        <template slot="contents">
            <div class="mb-12 mb-lg-20" style="flex: 0 0 auto;">
                <v-badge floating dot>
                    <h4 class="tit--sm line-height-1">근로자 계약서 목록</h4>
                </v-badge>
            </div>
            <template v-if="items.length">
                <div class="v-cards">
                    <employment-form-list-item v-for="item in items" :key="item._id" :value="item" v-bind="{ loading }" v-on="{ remove }" @input="updateItem" />
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        생성된 계약서가 없습니다.
                    </p>
                    <employment-form-form @input="updateItem">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text height="auto" color="transparent" class="v-btn--column">
                                <i class="icon icon-plus-lg" />
                                <span class="mt-6 mt-lg-14 grey-9--text">계약서 생성하기</span>
                            </v-btn>
                        </template>
                    </employment-form-form>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import EmploymentFormForm from "@/components/dashboard/company/employment/form/form/employment-form-form.vue";
import EmploymentFormListItem from "@/components/dashboard/company/employment/form/list/employment-form-list-item.vue";
import EmploymentContractForm from "@/components/dashboard/company/employment/contract/form/employment-contract-form.vue";

export default {
    components: {
        DashboardLayout,
        EmploymentFormForm,
        EmploymentFormListItem,
        EmploymentContractForm,
    },
    data: () => ({
        loading: false,
        forms: [],

        limit: 10,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        items() {
            return [...this.forms];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, forms } = await api.v1.company.employment.forms.gets({
                    headers: { skip, limit },
                    params,
                });
                this.forms = forms;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.forms.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.forms.splice(index, 1, item);
            else {
                this.forms = [item, ...this.forms];
                this.summary.totalCount += 1;
            }
            this.search();
        },

        async remove(item) {
            const go = confirm(`다음 계약서를 삭제하시겠습니까?\r\n명칭: ${item?.name || "제목없음"}`);
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                await api.v1.company.employment.files.delete({ _id: item._id })
                await api.v1.company.employment.forms.delete(item);
                this.search();
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
